/**
 * These convert to sequential integers equal to the array index
 */
export enum LogLevelEnum {
  ALL,
  DEBUG,
  INFO,
  WARN,
  ERROR,
  FATAL,
  OFF
}

export class LogEntry {
  level: LogLevelEnum;
  message: string;
  stack: string;
  time: Date;

  /**
   * Create a log entry object.
   * @param message: log message
   * @param level: log level, optional, default is ERROR
   */
  constructor(message: string, level?: LogLevelEnum) {
    this.level = level || LogLevelEnum.ERROR;
    this.message = message;
    this.time = new Date();
  }
}
